import { gentilicosTituloNameUpperCase, orgaosExpedidoresNameUpperCase } from '../../schemas'

export default function (validacaoNumeroLivroFolha, orgaosExpedidores, validaCpfCnpj, siglasEstados, gentilicos, estadoCivil, finalidade) {
  return {
    NAO_ONEROSO: {
      groups: [
        // 01 - caracteristicas do titulo
        {
          legend: '01 - CARACTERÍSTICAS DO TÍTULO',
          codigo: 'caracteristica_model',
          styleClasses: 'none',
          fields: [
            {
              column: 6,
              type: 'elementSelect',
              model: 'especie',
              inputName: 'especie',
              placeholder: 'Selecione',
              visible: true,
              disabled: false,
              required: true,
              validator: 'required',
              valueKey: 'name',
              values: [
                {
                  id: 'Título de Domínio',
                  name: 'TÍTULO DE DOMÍNIO'
                },
                {
                  id: 'Título de Reconhecimento de Domínio',
                  name: 'TÍTULO DE RECONHECIMENTO DE DOMÍNIO'
                },
                {
                  id: 'Título de Domínio Comunitário',
                  name: 'TÍTULO DE DOMÍNIO COMUNITÁRIO'
                },
                {
                  id: 'Outros',
                  name: 'OUTROS'
                }
              ],
              filterable: false,
              elementLabel: 'Especie: '
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'descricao',
              inputName: 'descricao',
              visible: false,
              disabled: false,
              required: false,
              readonly: false,
              styleClasses: '',
              validator: 'required',
              inputType: 'text',
              elementLabel: 'Descrição: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'numeroFolha',
              inputName: 'numeroFolha',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Nº do Título: ',
              clearable: true
            },
            {
              type: 'elementDatePicker',
              model: 'dataEmissao',
              inputName: 'dataEmissao',
              disabled: false,
              firstDayOfWeek: 1,
              elementLabel: 'Data de Emissão: ',
              placeholder: 'selecione a data',
              format: 'dd/MM/yyyy',
              dateType: 'date'
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'municipioEmissao',
              inputName: 'municipioEmissao',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Local de Emissão: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'ufEmissao',
              inputName: 'ufEmissao',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'UF: ',
              clearable: true
            },
            {
              column: 12,
              type: 'elementInput',
              model: 'numeroProcesso',
              inputName: 'numeroProcesso',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Processo Administrativo: ',
              clearable: true
            }
          ]
        },
        {
          legend: '02 - OUTORGANTE',
          styleClasses: 'none',
          fields: [
            {
              column: 24,
              type: 'elementInput',
              model: 'outorgante',
              inputName: 'outorgante',
              visible: true,
              validator: 'required',
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Nome do Outorgante: ',
              clearable: true
            }
          ]
        },
        {
          codigo: 'OUTORGADO',
          legend: '03 - OUTORGADO',
          styleClasses: 'none',
          fields: [
            {
              column: 24,
              type: 'elementInput',
              model: 'nomeOutorgado',
              inputName: 'nomeOutorgado',
              visible: true,
              validator: 'required',
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Nome do Outorgado: ',
              clearable: true,
              visiblePf: true,
              visiblePj: true
            },
            {
              type: 'elementSelect',
              model: 'nacionalidadeOutorgado',
              inputName: 'nacionalidadeOutorgado',
              placeholder: 'Selecione',
              visible: true,
              disabled: false,
              required: true,
              validator: 'required',
              valueKey: 'codigo',
              values: gentilicosTituloNameUpperCase,
              filterable: false,
              elementLabel: 'Nacionalidade: ',
              visiblePf: true,
              visiblePj: false
            },
            {
              type: 'elementSelect',
              model: 'estadoCivilOutorgado',
              inputName: 'estadoCivilOutorgado',
              placeholder: 'Selecione',
              visible: true,
              disabled: true,
              valueKey: 'codigo',
              values: estadoCivil,
              filterable: false,
              required: true,
              validator: 'required',
              elementLabel: 'Estado Civil: ',
              clearable: true,
              visiblePf: true,
              visiblePj: false
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'rgOutorgado',
              inputName: 'rgOutorgado',
              visible: true,
              disabled: false,
              required: false,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Nº do RG: ',
              clearable: true,
              visiblePf: true,
              visiblePj: false
            },
            {
              column: 6,
              type: 'elementSelect',
              model: 'orgaoExpedidorOutorgado',
              inputName: 'orgaoExpedidorOutorgadoSelect',
              placeholder: 'Selecione',
              visible: true,
              disabled: false,
              valueKey: 'codigo',
              values: orgaosExpedidoresNameUpperCase,
              filterable: false,
              required: false,
              elementLabel: 'Orgão expedidor: ',
              clearable: true,
              visiblePf: true,
              visiblePj: false
            },
            {
              column: 6,
              type: 'elementSelect',
              model: 'ufRgOutorgado',
              inputName: 'ufRgOutorgado',
              placeholder: 'Selecione',
              visible: true,
              disabled: false,
              required: false,
              valueKey: 'codigo',
              values: siglasEstados(),
              filterable: false,
              elementLabel: 'UF do RG: ',
              clearable: true,
              visiblePf: true,
              visiblePj: false
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'cpfCnpjOutorgado',
              inputName: 'cpfCnpjOutorgado',
              visible: true,
              disabled: false,
              required: true,
              validator: [validaCpfCnpj],
              readonly: false,
              inputType: 'text',
              elementLabel: 'CPF/CNPJ: ',
              clearable: true,
              visiblePf: true,
              visiblePj: true,
              maxlength: 17
            }
          ]
        },
        {
          codigo: 'CONJUGE',
          styleClasses: 'none',
          fields: [
            {
              column: 24,
              type: 'elementInput',
              model: 'nomeConjuge',
              inputName: 'nomeConjuge',
              visible: true,
              disabled: false,
              required: true,
              validator: 'required',
              readonly: false,
              inputType: 'text',
              elementLabel: 'Cônjuge do Outorgado: ',
              clearable: true
            },
            {
              type: 'elementSelect',
              model: 'nacionalidadeConjuge',
              inputName: 'nacionalidadeConjuge',
              placeholder: 'Selecione',
              visible: true,
              disabled: false,
              required: true,
              validator: 'required',
              valueKey: 'codigo',
              values: gentilicosTituloNameUpperCase,
              filterable: false,
              elementLabel: 'Nacionalidade: '
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'rgConjuge',
              inputName: 'rgConjuge',
              visible: true,
              disabled: false,
              required: false,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Nº do RG: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementSelect',
              model: 'orgaoExpedidorConjuge',
              inputName: 'orgaoExpedidorConjugeSelect',
              placeholder: 'Selecione',
              visible: true,
              disabled: false,
              required: false,
              valueKey: 'codigo',
              values: orgaosExpedidoresNameUpperCase,
              filterable: false,
              elementLabel: 'Orgão expedidor: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementSelect',
              model: 'ufRgConjuge',
              inputName: 'ufDoRgConjuge',
              placeholder: 'Selecione',
              visible: true,
              disabled: false,
              required: false,
              valueKey: 'codigo',
              values: siglasEstados(),
              filterable: false,
              elementLabel: 'UF do RG: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'cpfCnpjConjuge',
              inputName: 'cpfCnpjConjuge',
              visible: true,
              disabled: false,
              required: true,
              validator: [validaCpfCnpj],
              readonly: false,
              inputType: 'text',
              elementLabel: 'CPF/CNPJ: ',
              clearable: true,
              maxlength: 17
            }
          ]
        },
        {
          legend: '04 - DADOS DO IMÓVEL',
          codigo: 'CARACTERISTICA_IMOVEL',
          styleClasses: 'none',
          fields: [
            {
              column: 6,
              type: 'elementInput',
              model: 'latitude',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Latitude: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'longitude',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Longitude: ',
              clearable: true
            },
            {
              column: 12,
              type: 'elementInput',
              model: 'nomeImovel',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              validator: 'required',
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Nome do Imóvel: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'glebaImovel',
              inputName: 'input_name',
              visible: true,
              validator: 'required',
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Gleba do Imóvel: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'areaImovel',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Área do Imóvel: ',
              clearable: true,
              validator: [(value) => {
                if (value === '') {
                  return 'Área do imóvel é obrigatória'
                }
                if (value === '' || /^\d{1,3}(?:\.\d{3})*(?:,\d{1,4})?$|^\d+$/.test(value)) {
                  return []
                }
                return ['Área do imóvel inválida']
              }],
              set: (model, value) => {
                if (value === '') {
                  model.areaImovel = ''
                  return
                }
                let totCaracter = 14 // Total de caracteres máximo aceito contando as casas decimais e virgula
                let valueSemPonto = value.replace(/\./g, '')
                if (valueSemPonto.length <= totCaracter) {
                  const partes = value.split(',')
                  const teste = /^\d{1,3}(?:\.\d{3})*(?:,\d{1,4})?$|^\d+$/
                  if ((partes.length === 1 || ['', '0'].includes(partes[1]) || (partes[1].length <= 4 && partes[1]?.split('')?.pop() === '0')) && teste.test(partes[0])) {
                    model.areaImovel = value
                  } else if ((partes.length === 1 || partes[1].length <= 4) && (teste.test(value) || !isNaN(parseFloat(`${partes[0].replace(/[^0-9]/g, '')}.${partes[1]}`)))) {
                    const numeroFinal = parseFloat(`${partes[0].replace(/[^0-9]/g, '')}.${partes[1]}`).toLocaleString('pt-BR', {
                      maximumFractionDigits: 4
                    })
                    model.areaImovel = numeroFinal
                  }
                }
              }
            },
            {
              column: 12,
              type: 'elementInput',
              model: 'logradouroImovel',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Logradouro do Imóvel: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'numeroImovel',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Número do Imóvel: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'bairroImovel',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Bairro/Povoado: ',
              clearable: true
            },
            {
              column: 12,
              type: 'elementSelect',
              model: 'municipioImovel',
              inputName: 'especie',
              placeholder: 'Selecione',
              visible: true,
              validator: 'required',
              disabled: false,
              required: false,
              valueKey: 'name',
              values: [],
              filterable: true,
              elementLabel: 'Município do Imóvel: '
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'precoImovel',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Preço do Imóvel: ',
              clearable: true,
              validator: [(value) => {
                if (value === '') {
                  return 'Preço do imóvel é obrigatório'
                }
                if (value === '' || /^\d{1,3}(?:\.\d{3})*(?:,\d{1,2})?$|^\d+$/.test(value)) {
                  return []
                }
                return ['Preço do Imóvel inválido']
              }],
              set: (model, value) => {
                if (value === '') {
                  model.precoImovel = ''
                  return
                }
                let totCaracter = 14 // Total de caracteres máximo aceito contando as casas decimais e virgula
                let valueSemPonto = value.replace(/\./g, '')
                if (valueSemPonto.length <= totCaracter) {
                  const partes = value.split(',')
                  const teste = /^\d{1,3}(?:\.\d{3})*(?:,\d{1,2})?$|^\d+$/
                  if ((partes.length === 1 || ['', '0'].includes(partes[1]) || (partes[1].length <= 2 && partes[1]?.split('')?.pop() === '0')) && teste.test(partes[0])) {
                    model.precoImovel = value
                  } else if ((partes.length === 1 || partes[1].length <= 2) && (teste.test(value) || !isNaN(parseFloat(`${partes[0].replace(/[^0-9]/g, '')}.${partes[1]}`)))) {
                    const numeroFinal = parseFloat(`${partes[0].replace(/[^0-9]/g, '')}.${partes[1]}`).toLocaleString('pt-BR', {
                      maximumFractionDigits: 2
                    })
                    model.precoImovel = numeroFinal
                  }
                }
              }
            }
          ]
        },
        {
          legend: '05 - DADOS DO REGISTRO',
          codigo: 'DADOS_REGISTRO',
          styleClasses: 'none',
          fields: [
            {
              column: 6,
              type: 'elementInput',
              model: 'matriculaImovel',
              inputName: 'matriculaImovel',
              visible: true,
              disabled: false,
              required: false,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Matrícula: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'livroMatriculaImovel',
              inputName: 'livroMatriculaImovel',
              visible: true,
              disabled: false,
              required: false,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Livro: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'folhaMatriculaImovel',
              inputName: 'folhaMatriculaImovel',
              visible: true,
              disabled: false,
              required: false,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Folha: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'cartorioMatriculaImovel',
              inputName: 'cartorioMatriculaImovel',
              visible: true,
              disabled: false,
              required: false,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Cartório: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementSelect',
              model: 'municipioMatriculaImovel',
              inputName: 'municipioMatriculaImovel',
              placeholder: 'Selecione',
              visible: true,
              disabled: false,
              required: false,
              valueKey: 'name',
              values: [],
              filterable: true,
              elementLabel: 'Município: '
            }
          ]
        }
      ]
    },
    NAO_ONEROSO_FISICO: {
      groups: [
        // 01 - caracteristicas do titulo
        {
          legend: '01 - CARACTERÍSTICAS DO TÍTULO',
          codigo: 'caracteristica_model',
          styleClasses: 'none',
          fields: [
            {
              column: 6,
              type: 'elementSelect',
              model: 'especie',
              inputName: 'especie',
              placeholder: 'Selecione',
              visible: true,
              disabled: false,
              required: true,
              validator: 'required',
              valueKey: 'name',
              values: [
                {
                  id: 'Título de Domínio',
                  name: 'TÍTULO DE DOMÍNIO'
                },
                {
                  id: 'Título de Reconhecimento de Domínio',
                  name: 'TÍTULO DE RECONHECIMENTO DE DOMÍNIO'
                },
                {
                  id: 'Título de Domínio Comunitário',
                  name: 'TÍTULO DE DOMÍNIO COMUNITÁRIO'
                },
                {
                  id: 'Outros',
                  name: 'OUTROS'
                }
              ],
              filterable: false,
              elementLabel: 'Especie: '
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'descricao',
              inputName: 'descricao',
              visible: false,
              disabled: false,
              required: false,
              readonly: false,
              styleClasses: '',
              validator: 'required',
              inputType: 'text',
              elementLabel: 'Descrição: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'numeroFolha',
              inputName: 'numeroFolha',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Nº do Título: ',
              clearable: true
            },
            {
              type: 'elementDatePicker',
              model: 'dataEmissao',
              inputName: 'dataEmissao',
              disabled: false,
              firstDayOfWeek: 1,
              elementLabel: 'Data de Emissão: ',
              placeholder: 'selecione a data',
              format: 'dd/MM/yyyy',
              dateType: 'date'
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'municipioEmissao',
              inputName: 'municipioEmissao',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Local de Emissão: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'ufEmissao',
              inputName: 'ufEmissao',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'UF: ',
              clearable: true
            },
            {
              column: 12,
              type: 'elementInput',
              model: 'numeroProcesso',
              inputName: 'numeroProcesso',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Processo Administrativo: ',
              clearable: true
            }
          ]
        },
        {
          legend: '02 - OUTORGANTE',
          styleClasses: 'none',
          fields: [
            {
              column: 24,
              type: 'elementInput',
              model: 'outorgante',
              inputName: 'outorgante',
              visible: true,
              validator: 'required',
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Nome do Outorgante: ',
              clearable: true
            }
          ]
        },
        {
          codigo: 'OUTORGADO',
          legend: '03 - OUTORGADO',
          styleClasses: 'none',
          fields: [
            {
              column: 24,
              type: 'elementInput',
              model: 'nomeOutorgado',
              inputName: 'nomeOutorgado',
              visible: true,
              validator: 'required',
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Nome do Outorgado: ',
              clearable: true,
              visiblePf: true,
              visiblePj: true
            },
            {
              type: 'elementSelect',
              model: 'nacionalidadeOutorgado',
              inputName: 'nacionalidadeOutorgado',
              placeholder: 'Selecione',
              visible: true,
              disabled: false,
              required: true,
              validator: 'required',
              valueKey: 'codigo',
              values: gentilicosTituloNameUpperCase,
              filterable: false,
              elementLabel: 'Nacionalidade: ',
              visiblePf: true,
              visiblePj: false
            },
            {
              type: 'elementSelect',
              model: 'estadoCivilOutorgado',
              inputName: 'estadoCivilOutorgado',
              placeholder: 'Selecione',
              visible: true,
              disabled: true,
              valueKey: 'codigo',
              values: estadoCivil,
              filterable: false,
              required: true,
              validator: 'required',
              elementLabel: 'Estado Civil: ',
              clearable: true,
              visiblePf: true,
              visiblePj: false
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'rgOutorgado',
              inputName: 'rgOutorgado',
              visible: true,
              disabled: false,
              required: false,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Nº do RG: ',
              clearable: true,
              visiblePf: true,
              visiblePj: false
            },
            {
              column: 6,
              type: 'elementSelect',
              model: 'orgaoExpedidorOutorgado',
              inputName: 'orgaoExpedidorOutorgadoSelect',
              placeholder: 'Selecione',
              visible: true,
              disabled: false,
              valueKey: 'codigo',
              values: orgaosExpedidoresNameUpperCase,
              filterable: false,
              required: false,
              elementLabel: 'Orgão expedidor: ',
              clearable: true,
              visiblePf: true,
              visiblePj: false
            },
            {
              column: 6,
              type: 'elementSelect',
              model: 'ufRgOutorgado',
              inputName: 'ufRgOutorgado',
              placeholder: 'Selecione',
              visible: true,
              disabled: false,
              required: false,
              valueKey: 'codigo',
              values: siglasEstados(),
              filterable: false,
              elementLabel: 'UF do RG: ',
              clearable: true,
              visiblePf: true,
              visiblePj: false
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'cpfCnpjOutorgado',
              inputName: 'cpfCnpjOutorgado',
              visible: true,
              disabled: false,
              required: true,
              validator: [validaCpfCnpj],
              readonly: false,
              inputType: 'text',
              elementLabel: 'CPF/CNPJ: ',
              clearable: true,
              visiblePf: true,
              visiblePj: true,
              maxlength: 17
            }
          ]
        },
        {
          codigo: 'CONJUGE',
          styleClasses: 'none',
          fields: [
            {
              column: 24,
              type: 'elementInput',
              model: 'nomeConjuge',
              inputName: 'nomeConjuge',
              visible: true,
              disabled: false,
              required: true,
              validator: 'required',
              readonly: false,
              inputType: 'text',
              elementLabel: 'Cônjuge do Outorgado: ',
              clearable: true
            },
            {
              type: 'elementSelect',
              model: 'nacionalidadeConjuge',
              inputName: 'nacionalidadeConjuge',
              placeholder: 'Selecione',
              visible: true,
              disabled: false,
              required: true,
              validator: 'required',
              valueKey: 'codigo',
              values: gentilicosTituloNameUpperCase,
              filterable: false,
              elementLabel: 'Nacionalidade: '
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'rgConjuge',
              inputName: 'rgConjuge',
              visible: true,
              disabled: false,
              required: false,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Nº do RG: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementSelect',
              model: 'orgaoExpedidorConjuge',
              inputName: 'orgaoExpedidorConjugeSelect',
              placeholder: 'Selecione',
              visible: true,
              disabled: false,
              required: false,
              valueKey: 'codigo',
              values: orgaosExpedidoresNameUpperCase,
              filterable: false,
              elementLabel: 'Orgão expedidor: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementSelect',
              model: 'ufRgConjuge',
              inputName: 'ufDoRgConjuge',
              placeholder: 'Selecione',
              visible: true,
              disabled: false,
              required: false,
              valueKey: 'codigo',
              values: siglasEstados(),
              filterable: false,
              elementLabel: 'UF do RG: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'cpfCnpjConjuge',
              inputName: 'cpfCnpjConjuge',
              visible: true,
              disabled: false,
              required: true,
              validator: [validaCpfCnpj],
              readonly: false,
              inputType: 'text',
              elementLabel: 'CPF/CNPJ: ',
              clearable: true,
              maxlength: 17
            }
          ]
        },
        {
          legend: '04 - DADOS DO IMÓVEL',
          codigo: 'CARACTERISTICA_IMOVEL',
          styleClasses: 'none',
          fields: [
            {
              column: 6,
              type: 'elementInput',
              model: 'latitude',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Latitude: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'longitude',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Longitude: ',
              clearable: true
            },
            {
              column: 12,
              type: 'elementInput',
              model: 'nomeImovel',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              validator: 'required',
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Nome do Imóvel: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'glebaImovel',
              inputName: 'input_name',
              visible: true,
              validator: 'required',
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Gleba do Imóvel: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'areaImovel',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Área do Imóvel: ',
              clearable: true,
              validator: [(value) => {
                if (value === '') {
                  return 'Área do imóvel é obrigatória'
                }
                if (value === '' || /^\d{1,3}(?:\.\d{3})*(?:,\d{1,4})?$|^\d+$/.test(value)) {
                  return []
                }
                return ['Área do imóvel inválida']
              }],
              set: (model, value) => {
                if (value === '') {
                  model.areaImovel = ''
                  return
                }
                let totCaracter = 14 // Total de caracteres máximo aceito contando as casas decimais e virgula
                let valueSemPonto = value.replace(/\./g, '')
                if (valueSemPonto.length <= totCaracter) {
                  const partes = value.split(',')
                  const teste = /^\d{1,3}(?:\.\d{3})*(?:,\d{1,4})?$|^\d+$/
                  if ((partes.length === 1 || ['', '0'].includes(partes[1]) || (partes[1].length <= 2 && partes[1]?.split('')?.pop() === '0')) && teste.test(partes[0])) {
                    model.areaImovel = value
                  } else if ((partes.length === 1 || partes[1].length <= 4) && (teste.test(value) || !isNaN(parseFloat(`${partes[0].replace(/[^0-9]/g, '')}.${partes[1]}`)))) {
                    const numeroFinal = parseFloat(`${partes[0].replace(/[^0-9]/g, '')}.${partes[1]}`).toLocaleString('pt-BR', {
                      maximumFractionDigits: 4
                    })
                    model.areaImovel = numeroFinal
                  }
                }
              }
            },
            {
              column: 12,
              type: 'elementInput',
              model: 'logradouroImovel',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Logradouro do Imóvel: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'numeroImovel',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Número do Imóvel: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'bairroImovel',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Bairro/Povoado: ',
              clearable: true
            },
            {
              column: 12,
              type: 'elementSelect',
              model: 'municipioImovel',
              inputName: 'especie',
              placeholder: 'Selecione',
              visible: true,
              validator: 'required',
              disabled: false,
              required: false,
              valueKey: 'name',
              values: [],
              filterable: true,
              elementLabel: 'Município do Imóvel: '
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'precoImovel',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Preço do Imóvel: ',
              clearable: true,
              validator: [(value) => {
                if (value === '') {
                  return 'Preço do imóvel é obrigatório'
                }
                if (value === '' || /^\d{1,3}(?:\.\d{3})*(?:,\d{1,2})?$|^\d+$/.test(value)) {
                  return []
                }
                return ['Preço do Imóvel inválido']
              }],
              set: (model, value) => {
                if (value === '') {
                  model.precoImovel = ''
                  return
                }
                let totCaracter = 14 // Total de caracteres máximo aceito contando as casas decimais e virgula
                let valueSemPonto = value.replace(/\./g, '')
                if (valueSemPonto.length <= totCaracter) {
                  const partes = value.split(',')
                  const teste = /^\d{1,3}(?:\.\d{3})*(?:,\d{1,2})?$|^\d+$/
                  if ((partes.length === 1 || partes[1] === '') && teste.test(partes[0])) {
                    model.precoImovel = value
                  } else if ((partes.length === 1 || partes[1].length <= 2) && (teste.test(value) || !isNaN(parseFloat(`${partes[0].replace(/[^0-9]/g, '')}.${partes[1]}`)))) {
                    const numeroFinal = parseFloat(`${partes[0].replace(/[^0-9]/g, '')}.${partes[1]}`).toLocaleString('pt-BR', {
                      maximumFractionDigits: 2
                    })
                    model.precoImovel = numeroFinal
                  }
                }
              }
            }
          ]
        },
        {
          legend: '05 - DADOS DO REGISTRO',
          codigo: 'DADOS_REGISTRO',
          styleClasses: 'none',
          fields: [
            {
              column: 6,
              type: 'elementInput',
              model: 'matriculaImovel',
              inputName: 'matriculaImovel',
              visible: true,
              disabled: false,
              required: false,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Matrícula: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'livroMatriculaImovel',
              inputName: 'livroMatriculaImovel',
              visible: true,
              disabled: false,
              required: false,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Livro: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'folhaMatriculaImovel',
              inputName: 'folhaMatriculaImovel',
              visible: true,
              disabled: false,
              required: false,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Folha: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'cartorio',
              inputName: 'cartorio',
              visible: true,
              disabled: false,
              required: false,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Cartório: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementSelect',
              model: 'municipioMatriculaImovel',
              inputName: 'municipioMatriculaImovel',
              placeholder: 'Selecione',
              visible: true,
              disabled: false,
              required: false,
              valueKey: 'name',
              values: [],
              filterable: true,
              elementLabel: 'Município: '
            }
          ]
        }
      ]
    },
    ONEROSO: {
      groups: [
        // 01 - caracteristicas do titulo
        {
          legend: '01 - CARACTERÍSTICAS DO TÍTULO',
          codigo: 'caracteristica_model',
          styleClasses: 'none',
          fields: [
            {
              column: 6,
              type: 'elementSelect',
              model: 'especie',
              inputName: 'especie',
              placeholder: 'Selecione',
              visible: true,
              disabled: false,
              required: true,
              validator: 'required',
              valueKey: 'name',
              values: [
                {
                  id: 'Título de Domínio',
                  name: 'Título de Domínio'
                },
                {
                  id: 'Título de Reconhecimento de Domínio',
                  name: 'Título de Reconhecimento de Domínio'
                },
                {
                  id: 'Título de Domínio Comunitário',
                  name: 'Título de Domínio Comunitário'
                },
                {
                  id: 'Outros',
                  name: 'Outros'
                }
              ],
              filterable: false,
              elementLabel: 'Especie: '
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'descricao',
              inputName: 'descricao',
              visible: false,
              disabled: false,
              required: false,
              readonly: false,
              styleClasses: '',
              validator: 'required',
              inputType: 'text',
              elementLabel: 'Descrição: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'numeroFolha',
              inputName: 'numeroFolha',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Nº do Título: ',
              clearable: true
            },
            {
              type: 'elementDatePicker',
              model: 'dataEmissao',
              inputName: 'dataEmissao',
              disabled: false,
              firstDayOfWeek: 1,
              elementLabel: 'Data de Emissão: ',
              placeholder: 'selecione a data',
              format: 'dd/MM/yyyy',
              dateType: 'date'
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'municipioEmissao',
              inputName: 'municipioEmissao',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Local de Emissão: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'ufEmissao',
              inputName: 'ufEmissao',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'UF: ',
              clearable: true
            },
            {
              column: 12,
              type: 'elementInput',
              model: 'numeroProcesso',
              inputName: 'numeroProcesso',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Processo Administrativo: ',
              clearable: true
            }
          ]
        },
        {
          legend: '02 - OUTORGANTE',
          styleClasses: 'none',
          fields: [
            {
              column: 24,
              type: 'elementInput',
              model: 'outorgante',
              inputName: 'outorgante',
              visible: true,
              validator: 'required',
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Nome do Outorgante: ',
              clearable: true
            }
          ]
        },
        {
          codigo: 'OUTORGADO',
          legend: '03 - OUTORGADO',
          styleClasses: 'none',
          fields: [
            {
              column: 24,
              type: 'elementInput',
              model: 'nomeOutorgado',
              inputName: 'nomeOutorgado',
              visible: true,
              validator: 'required',
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Nome do Outorgado: ',
              clearable: true,
              visiblePf: true,
              visiblePj: true
            },
            {
              type: 'elementSelect',
              model: 'nacionalidadeOutorgado',
              inputName: 'nacionalidadeOutorgado',
              placeholder: 'Selecione',
              visible: true,
              disabled: false,
              required: true,
              validator: 'required',
              valueKey: 'codigo',
              values: gentilicosTituloNameUpperCase,
              filterable: false,
              elementLabel: 'Nacionalidade: ',
              visiblePf: true,
              visiblePj: false
            },
            {
              type: 'elementSelect',
              model: 'estadoCivilOutorgado',
              inputName: 'estadoCivilOutorgado',
              placeholder: 'Selecione',
              visible: true,
              disabled: true,
              valueKey: 'codigo',
              filterable: false,
              required: true,
              validator: 'required',
              elementLabel: 'Estado Civil: ',
              clearable: true,
              visiblePf: true,
              visiblePj: false
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'rgOutorgado',
              inputName: 'rgOutorgado',
              visible: true,
              disabled: false,
              required: false,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Nº do RG: ',
              clearable: true,
              visiblePf: true,
              visiblePj: false
            },
            {
              column: 6,
              type: 'elementSelect',
              model: 'orgaoExpedidorOutorgado',
              inputName: 'orgaoExpedidorOutorgadoSelect',
              placeholder: 'Selecione',
              visible: true,
              disabled: false,
              valueKey: 'codigo',
              values: orgaosExpedidoresNameUpperCase,
              filterable: false,
              required: false,
              elementLabel: 'Orgão expedidor: ',
              clearable: true,
              visiblePf: true,
              visiblePj: false
            },
            {
              column: 6,
              type: 'elementSelect',
              model: 'ufRgOutorgado',
              inputName: 'ufRgOutorgado',
              placeholder: 'Selecione',
              visible: true,
              disabled: false,
              required: false,
              valueKey: 'codigo',
              values: siglasEstados(),
              filterable: false,
              elementLabel: 'UF do RG: ',
              clearable: true,
              visiblePf: true,
              visiblePj: false
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'cpfCnpjOutorgado',
              inputName: 'cpfCnpjOutorgado',
              visible: true,
              disabled: false,
              required: true,
              validator: [validaCpfCnpj],
              readonly: false,
              inputType: 'text',
              elementLabel: 'CPF/CNPJ: ',
              clearable: true,
              visiblePf: true,
              visiblePj: true,
              maxlength: 17
            }
          ]
        },
        {
          codigo: 'CONJUGE',
          styleClasses: 'none',
          fields: [
            {
              column: 24,
              type: 'elementInput',
              model: 'nomeConjuge',
              inputName: 'nomeConjuge',
              visible: true,
              disabled: false,
              required: true,
              validator: 'required',
              readonly: false,
              inputType: 'text',
              elementLabel: 'Cônjuge do Outorgado: ',
              clearable: true
            },
            {
              type: 'elementSelect',
              model: 'nacionalidadeConjuge',
              inputName: 'nacionalidadeConjuge',
              placeholder: 'Selecione',
              visible: true,
              disabled: false,
              required: true,
              validator: 'required',
              valueKey: 'codigo',
              values: gentilicos,
              filterable: false,
              elementLabel: 'Nacionalidade: '
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'rgConjuge',
              inputName: 'rgConjuge',
              visible: true,
              disabled: false,
              required: false,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Nº do RG: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementSelect',
              model: 'orgaoExpedidorConjuge',
              inputName: 'orgaoExpedidorConjugeSelect',
              placeholder: 'Selecione',
              visible: true,
              disabled: false,
              required: false,
              valueKey: 'codigo',
              values: orgaosExpedidoresNameUpperCase,
              filterable: false,
              elementLabel: 'Orgão expedidor: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementSelect',
              model: 'ufRgConjuge',
              inputName: 'ufDoRgConjuge',
              placeholder: 'Selecione',
              visible: true,
              disabled: false,
              required: false,
              valueKey: 'codigo',
              values: siglasEstados(),
              filterable: false,
              elementLabel: 'UF do RG: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'cpfCnpjConjuge',
              inputName: 'cpfCnpjConjuge',
              visible: true,
              disabled: false,
              required: true,
              validator: [validaCpfCnpj],
              readonly: false,
              inputType: 'text',
              elementLabel: 'CPF/CNPJ: ',
              clearable: true,
              maxlength: 17
            }
          ]
        },
        {
          legend: '04 - DADOS DO IMÓVEL',
          codigo: 'CARACTERISTICA_IMOVEL',
          styleClasses: 'none',
          fields: [
            {
              column: 6,
              type: 'elementInput',
              model: 'latitude',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Latitude: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'longitude',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Longitude: ',
              clearable: true
            },
            {
              column: 12,
              type: 'elementInput',
              model: 'nomeImovel',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              validator: 'required',
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Nome do Imóvel: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'glebaImovel',
              inputName: 'input_name',
              visible: true,
              validator: 'required',
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Gleba do Imóvel: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'areaImovel',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              validator: [(value) => {
                if (value === '') {
                  return 'Área do imóvel é obrigatória'
                }
                if (value === '' || /^\d{1,3}(?:\.\d{3})*(?:,\d{1,4})?$|^\d+$/.test(value)) {
                  return []
                }
                return ['Área do imóvel inválida']
              }],
              elementLabel: 'Área do Imóvel: ',
              clearable: true,
              set: (model, value) => {
                if (value === '') {
                  model.areaImovel = ''
                  return
                }
                let totCaracter = 14 // Total de caracteres máximo aceito contando as casas decimais e virgula
                let valueSemPonto = value.replace(/\./g, '')
                if (valueSemPonto.length <= totCaracter) {
                  const partes = value.split(',')
                  const teste = /^\d{1,3}(?:\.\d{3})*(?:,\d{1,4})?$|^\d+$/
                  if ((partes.length === 1 || ['', '0'].includes(partes[1]) || (partes[1].length <= 4 && partes[1]?.split('')?.pop() === '0')) && teste.test(partes[0])) {
                    model.areaImovel = value
                  } else if ((partes.length === 1 || partes[1].length <= 4) && (teste.test(value) || !isNaN(parseFloat(`${partes[0].replace(/[^0-9]/g, '')}.${partes[1]}`)))) {
                    const numeroFinal = parseFloat(`${partes[0].replace(/[^0-9]/g, '')}.${partes[1]}`).toLocaleString('pt-BR', {
                      maximumFractionDigits: 4
                    })
                    model.areaImovel = numeroFinal
                  }
                }
              }
            },
            {
              column: 12,
              type: 'elementInput',
              model: 'logradouroImovel',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Logradouro do Imóvel: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'numeroImovel',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Número do Imóvel: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'bairroImovel',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Bairro/Povoado: ',
              clearable: true
            },
            {
              column: 12,
              type: 'elementSelect',
              model: 'municipioImovel',
              inputName: 'especie',
              placeholder: 'Selecione',
              visible: true,
              validator: 'required',
              disabled: false,
              required: false,
              valueKey: 'name',
              values: [],
              filterable: true,
              elementLabel: 'Município do Imóvel: '
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'precoImovel',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Preço do Imóvel: ',
              clearable: true,
              validator: [(value) => {
                if (value === '') {
                  return 'Preço do imóvel é obrigatório'
                }
                if (value === '' || /^\d{1,3}(?:\.\d{3})*(?:,\d{1,2})?$|^\d+$/.test(value)) {
                  return []
                }
                return ['Preço do Imóvel inválido']
              }],
              set: (model, value) => {
                if (value === '') {
                  model.precoImovel = ''
                  return
                }
                let totCaracter = 14 // Total de caracteres máximo aceito contando as casas decimais e virgula
                let valueSemPonto = value.replace(/\./g, '')
                if (valueSemPonto.length <= totCaracter) {
                  const partes = value.split(',')
                  const teste = /^\d{1,3}(?:\.\d{3})*(?:,\d{1,2})?$|^\d+$/
                  if ((partes.length === 1 || ['', '0'].includes(partes[1]) || (partes[1].length <= 2 && partes[1]?.split('')?.pop() === '0')) && teste.test(partes[0])) {
                    model.precoImovel = value
                  } else if ((partes.length === 1 || partes[1].length <= 2) && (teste.test(value) || !isNaN(parseFloat(`${partes[0].replace(/[^0-9]/g, '')}.${partes[1]}`)))) {
                    const numeroFinal = parseFloat(`${partes[0].replace(/[^0-9]/g, '')}.${partes[1]}`).toLocaleString('pt-BR', {
                      maximumFractionDigits: 2
                    })
                    model.precoImovel = numeroFinal
                  }
                }
              }
            }
          ]
        },
        {
          legend: '05 - DADOS DO REGISTRO',
          codigo: 'DADOS_REGISTRO',
          styleClasses: 'none',
          fields: [
            {
              column: 6,
              type: 'elementInput',
              model: 'matriculaImovel',
              inputName: 'matriculaImovel',
              visible: true,
              disabled: false,
              required: false,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Matrícula: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'livroMatriculaImovel',
              inputName: 'livroMatriculaImovel',
              visible: true,
              disabled: false,
              required: false,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Livro: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'folhaMatriculaImovel',
              inputName: 'folhaMatriculaImovel',
              visible: true,
              disabled: false,
              required: false,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Folha: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'cartorioMatriculaImovel',
              inputName: 'cartorioMatriculaImovel',
              visible: true,
              disabled: false,
              required: false,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Cartório: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementSelect',
              model: 'municipioMatriculaImovel',
              inputName: 'municipioMatriculaImovel',
              placeholder: 'Selecione',
              visible: true,
              disabled: false,
              required: false,
              valueKey: 'name',
              values: [],
              filterable: true,
              elementLabel: 'Município: '
            }
          ]
        }
      ]
    },
    ONEROSO_FISICO: {
      groups: [
        // 01 - caracteristicas do titulo
        {
          legend: '01 - CARACTERÍSTICAS DO TÍTULO',
          codigo: 'caracteristica_model',
          styleClasses: 'none',
          fields: [
            {
              column: 6,
              type: 'elementSelect',
              model: 'especie',
              inputName: 'especie',
              placeholder: 'Selecione',
              visible: true,
              disabled: false,
              required: true,
              validator: 'required',
              valueKey: 'name',
              values: [
                {
                  id: 'Título de Domínio',
                  name: 'Título de Domínio'
                },
                {
                  id: 'Título de Reconhecimento de Domínio',
                  name: 'Título de Reconhecimento de Domínio'
                },
                {
                  id: 'Título de Domínio Comunitário',
                  name: 'Título de Domínio Comunitário'
                },
                {
                  id: 'Outros',
                  name: 'Outros'
                }
              ],
              filterable: false,
              elementLabel: 'Especie: '
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'descricao',
              inputName: 'descricao',
              visible: false,
              disabled: false,
              required: false,
              readonly: false,
              styleClasses: '',
              validator: 'required',
              inputType: 'text',
              elementLabel: 'Descrição: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'numeroFolha',
              inputName: 'numeroFolha',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Nº do Título: ',
              clearable: true
            },
            {
              type: 'elementDatePicker',
              model: 'dataEmissao',
              inputName: 'dataEmissao',
              disabled: false,
              firstDayOfWeek: 1,
              elementLabel: 'Data de Emissão: ',
              placeholder: 'selecione a data',
              format: 'dd/MM/yyyy',
              dateType: 'date'
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'municipioEmissao',
              inputName: 'municipioEmissao',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Local de Emissão: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'ufEmissao',
              inputName: 'ufEmissao',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'UF: ',
              clearable: true
            },
            {
              column: 12,
              type: 'elementInput',
              model: 'numeroProcesso',
              inputName: 'numeroProcesso',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Processo Administrativo: ',
              clearable: true
            }
          ]
        },
        {
          legend: '02 - OUTORGANTE',
          styleClasses: 'none',
          fields: [
            {
              column: 24,
              type: 'elementInput',
              model: 'outorgante',
              inputName: 'outorgante',
              visible: true,
              validator: 'required',
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Nome do Outorgante: ',
              clearable: true
            }
          ]
        },
        {
          codigo: 'OUTORGADO',
          legend: '03 - OUTORGADO',
          styleClasses: 'none',
          fields: [
            {
              column: 24,
              type: 'elementInput',
              model: 'nomeOutorgado',
              inputName: 'nomeOutorgado',
              visible: true,
              validator: 'required',
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Nome do Outorgado: ',
              clearable: true,
              visiblePf: true,
              visiblePj: true
            },
            {
              type: 'elementSelect',
              model: 'nacionalidadeOutorgado',
              inputName: 'nacionalidadeOutorgado',
              placeholder: 'Selecione',
              visible: true,
              disabled: false,
              required: true,
              validator: 'required',
              valueKey: 'codigo',
              values: gentilicosTituloNameUpperCase,
              filterable: false,
              elementLabel: 'Nacionalidade: ',
              visiblePf: true,
              visiblePj: false
            },
            {
              type: 'elementSelect',
              model: 'estadoCivilOutorgado',
              inputName: 'estadoCivilOutorgado',
              placeholder: 'Selecione',
              visible: true,
              disabled: true,
              valueKey: 'codigo',
              filterable: false,
              required: true,
              validator: 'required',
              elementLabel: 'Estado Civil: ',
              clearable: true,
              visiblePf: true,
              visiblePj: false
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'rgOutorgado',
              inputName: 'rgOutorgado',
              visible: true,
              disabled: false,
              required: false,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Nº do RG: ',
              clearable: true,
              visiblePf: true,
              visiblePj: false
            },
            {
              column: 6,
              type: 'elementSelect',
              model: 'orgaoExpedidorOutorgado',
              inputName: 'orgaoExpedidorOutorgadoSelect',
              placeholder: 'Selecione',
              visible: true,
              disabled: false,
              valueKey: 'codigo',
              values: orgaosExpedidoresNameUpperCase,
              filterable: false,
              required: false,
              elementLabel: 'Orgão expedidor: ',
              clearable: true,
              visiblePf: true,
              visiblePj: false
            },
            {
              column: 6,
              type: 'elementSelect',
              model: 'ufRgOutorgado',
              inputName: 'ufRgOutorgado',
              placeholder: 'Selecione',
              visible: true,
              disabled: false,
              required: false,
              valueKey: 'codigo',
              values: siglasEstados(),
              filterable: false,
              elementLabel: 'UF do RG: ',
              clearable: true,
              visiblePf: true,
              visiblePj: false
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'cpfCnpjOutorgado',
              inputName: 'cpfCnpjOutorgado',
              visible: true,
              disabled: false,
              required: true,
              validator: [validaCpfCnpj],
              readonly: false,
              inputType: 'text',
              elementLabel: 'CPF/CNPJ: ',
              clearable: true,
              visiblePf: true,
              visiblePj: true,
              maxlength: 17
            }
          ]
        },
        {
          codigo: 'CONJUGE',
          styleClasses: 'none',
          fields: [
            {
              column: 24,
              type: 'elementInput',
              model: 'nomeConjuge',
              inputName: 'nomeConjuge',
              visible: true,
              disabled: false,
              required: true,
              validator: 'required',
              readonly: false,
              inputType: 'text',
              elementLabel: 'Cônjuge do Outorgado: ',
              clearable: true
            },
            {
              type: 'elementSelect',
              model: 'nacionalidadeConjuge',
              inputName: 'nacionalidadeConjuge',
              placeholder: 'Selecione',
              visible: true,
              disabled: false,
              required: true,
              validator: 'required',
              valueKey: 'codigo',
              values: gentilicos,
              filterable: false,
              elementLabel: 'Nacionalidade: '
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'rgConjuge',
              inputName: 'rgConjuge',
              visible: true,
              disabled: false,
              required: false,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Nº do RG: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementSelect',
              model: 'orgaoExpedidorConjuge',
              inputName: 'orgaoExpedidorConjugeSelect',
              placeholder: 'Selecione',
              visible: true,
              disabled: false,
              required: false,
              valueKey: 'codigo',
              values: orgaosExpedidoresNameUpperCase,
              filterable: false,
              elementLabel: 'Orgão expedidor: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementSelect',
              model: 'ufRgConjuge',
              inputName: 'ufDoRgConjuge',
              placeholder: 'Selecione',
              visible: true,
              disabled: false,
              required: false,
              valueKey: 'codigo',
              values: siglasEstados(),
              filterable: false,
              elementLabel: 'UF do RG: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'cpfCnpjConjuge',
              inputName: 'cpfCnpjConjuge',
              visible: true,
              disabled: false,
              required: true,
              validator: [validaCpfCnpj],
              readonly: false,
              inputType: 'text',
              elementLabel: 'CPF/CNPJ: ',
              clearable: true,
              maxlength: 17
            }
          ]
        },
        {
          legend: '04 - DADOS DO IMÓVEL',
          codigo: 'CARACTERISTICA_IMOVEL',
          styleClasses: 'none',
          fields: [
            {
              column: 6,
              type: 'elementInput',
              model: 'latitude',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Latitude: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'longitude',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Longitude: ',
              clearable: true
            },
            {
              column: 12,
              type: 'elementInput',
              model: 'nomeImovel',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              validator: 'required',
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Nome do Imóvel: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'glebaImovel',
              inputName: 'input_name',
              visible: true,
              validator: 'required',
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Gleba do Imóvel: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'areaImovel',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              validator: [(value) => {
                if (value === '') {
                  return 'Área do imóvel é obrigatória'
                }
                if (value === '' || /^\d{1,3}(?:\.\d{3})*(?:,\d{1,4})?$|^\d+$/.test(value)) {
                  return []
                }
                return ['Área do imóvel inválida']
              }],
              elementLabel: 'Área do Imóvel: ',
              clearable: true,
              set: (model, value) => {
                if (value === '') {
                  model.areaImovel = ''
                  return
                }
                let totCaracter = 14 // Total de caracteres máximo aceito contando as casas decimais e virgula
                let valueSemPonto = value.replace(/\./g, '')
                if (valueSemPonto.length <= totCaracter) {
                  const partes = value.split(',')
                  const teste = /^\d{1,3}(?:\.\d{3})*(?:,\d{1,4})?$|^\d+$/
                  if ((partes.length === 1 || ['', '0'].includes(partes[1]) || (partes[1].length <= 4 && partes[1]?.split('')?.pop() === '0')) && teste.test(partes[0])) {
                    model.areaImovel = value
                  } else if ((partes.length === 1 || partes[1].length <= 4) && (teste.test(value) || !isNaN(parseFloat(`${partes[0].replace(/[^0-9]/g, '')}.${partes[1]}`)))) {
                    const numeroFinal = parseFloat(`${partes[0].replace(/[^0-9]/g, '')}.${partes[1]}`).toLocaleString('pt-BR', {
                      maximumFractionDigits: 4
                    })
                    model.areaImovel = numeroFinal
                  }
                }
              }
            },
            {
              column: 12,
              type: 'elementInput',
              model: 'logradouroImovel',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Logradouro do Imóvel: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'numeroImovel',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Número do Imóvel: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'bairroImovel',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Bairro/Povoado: ',
              clearable: true
            },
            {
              column: 12,
              type: 'elementSelect',
              model: 'municipioImovel',
              inputName: 'especie',
              placeholder: 'Selecione',
              visible: true,
              validator: 'required',
              disabled: false,
              required: false,
              valueKey: 'name',
              values: [],
              filterable: true,
              elementLabel: 'Município do Imóvel: '
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'precoImovel',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Preço do Imóvel: ',
              clearable: true,
              validator: [(value) => {
                if (value === '') {
                  return 'Preço do imóvel é obrigatório'
                }
                if (value === '' || /^\d{1,3}(?:\.\d{3})*(?:,\d{1,2})?$|^\d+$/.test(value)) {
                  return []
                }
                return ['Preço do Imóvel inválido']
              }],
              set: (model, value) => {
                if (value === '') {
                  model.precoImovel = ''
                  return
                }
                let totCaracter = 14 // Total de caracteres máximo aceito contando as casas decimais e virgula
                let valueSemPonto = value.replace(/\./g, '')
                if (valueSemPonto.length <= totCaracter) {
                  const partes = value.split(',')
                  const teste = /^\d{1,3}(?:\.\d{3})*(?:,\d{1,2})?$|^\d+$/
                  if ((partes.length === 1 || ['', '0'].includes(partes[1]) || (partes[1].length <= 2 && partes[1]?.split('')?.pop() === '0')) && teste.test(partes[0])) {
                    model.precoImovel = value
                  } else if ((partes.length === 1 || partes[1].length <= 2) && (teste.test(value) || !isNaN(parseFloat(`${partes[0].replace(/[^0-9]/g, '')}.${partes[1]}`)))) {
                    const numeroFinal = parseFloat(`${partes[0].replace(/[^0-9]/g, '')}.${partes[1]}`).toLocaleString('pt-BR', {
                      maximumFractionDigits: 2
                    })
                    model.precoImovel = numeroFinal
                  }
                }
              }
            }
          ]
        },
        {
          legend: '05 - DADOS DO REGISTRO',
          codigo: 'DADOS_REGISTRO',
          styleClasses: 'none',
          fields: [
            {
              column: 6,
              type: 'elementInput',
              model: 'matriculaImovel',
              inputName: 'matriculaImovel',
              visible: true,
              disabled: false,
              required: false,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Matrícula: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'livroMatriculaImovel',
              inputName: 'livroMatriculaImovel',
              visible: true,
              disabled: false,
              required: false,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Livro: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'folhaMatriculaImovel',
              inputName: 'folhaMatriculaImovel',
              visible: true,
              disabled: false,
              required: false,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Folha: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'cartorioMatriculaImovel',
              inputName: 'cartorioMatriculaImovel',
              visible: true,
              disabled: false,
              required: false,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Cartório: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementSelect',
              model: 'municipioMatriculaImovel',
              inputName: 'municipioMatriculaImovel',
              placeholder: 'Selecione',
              visible: true,
              disabled: false,
              required: false,
              valueKey: 'name',
              values: [],
              filterable: true,
              elementLabel: 'Município: '
            }
          ]
        }
      ]
    },
    CERTIDAO_TITULO: {
      groups: [
        {
          styleClasses: 'none',
          fields: [
            {
              column: 6,
              type: 'elementInput',
              model: 'numeroDaCertidao',
              inputName: 'numeroDaCertidao',
              visible: true,
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Nº da Certidão: ',
              validator: [validacaoNumeroLivroFolha],
              maxlength: 3,
              clearable: true
            },
            {
              column: 6,
              required: true,
              type: 'elementInput',
              model: 'numeroLivro',
              inputName: 'numeroLivro',
              visible: true,
              disabled: true,
              readonly: false,
              styleClasses: '',
              inputType: 'number',
              elementLabel: 'Nº do Livro: ',
              clearable: true
            }
          ]
        },
        {
          styleClasses: 'none',
          fields: [
            {
              column: 24,
              type: 'app-text-area',
              model: 'textoCertidao',
              id: 'textarea_id',
              inputName: 'textoCertidao',
              visible: true,
              required: true,
              validator: 'required',
              disabled: false,
              elementLabel: 'Texto da certidao: ',
              autosize: false
            }
          ]
        }
      ]
    },
    PEAEX: {
      groups: [
        {
          styleClasses: 'none',
          fields: [
            {
              column: 6,
              type: 'elementInput',
              model: 'numeroDaCertidao',
              inputName: 'numeroDaCertidao',
              visible: true,
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Nº da Certidão: ',
              validator: [validacaoNumeroLivroFolha],
              maxlength: 3,
              clearable: true
            },
            {
              column: 6,
              required: true,
              type: 'elementInput',
              model: 'numeroLivro',
              inputName: 'numeroLivro',
              visible: true,
              disabled: true,
              readonly: false,
              styleClasses: '',
              inputType: 'number',
              elementLabel: 'Nº do Livro: ',
              clearable: true
            }
          ]
        },
        {
          styleClasses: 'none',
          fields: [
            {
              column: 24,
              type: 'app-text-area',
              model: 'textoCertidao',
              id: 'textarea_id',
              inputName: 'textoCertidao',
              visible: true,
              required: true,
              validator: 'required',
              disabled: false,
              elementLabel: 'Texto da certidao: ',
              autosize: false
            }
          ]
        }
      ]
    },
    TT: {
      groups: [
        {
          styleClasses: 'none',
          fields: [
            {
              column: 6,
              required: true,
              type: 'elementInput',
              model: 'numeroFolha',
              inputName: 'numeroFolha',
              visible: true,
              disabled: false,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Nº do Título: ',
              clearable: true
            }
          ]
        },
        {
          styleClasses: 'none',
          fields: [
            {
              column: 24,
              type: 'app-text-area',
              model: 'textoCertidao',
              id: 'textarea_id',
              inputName: 'textoCertidao',
              visible: true,
              required: true,
              validator: 'required',
              disabled: false,
              elementLabel: 'Texto da certidao: ',
              autosize: true
            }
          ]
        }
      ]
    },
    PEAS: {
      groups: [
        {
          styleClasses: 'none',
          fields: [
            {
              column: 6,
              required: true,
              type: 'elementInput',
              model: 'numeroLivro',
              inputName: 'numeroLivro',
              visible: true,
              disabled: false,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Nº do Título: ',
              clearable: true
            }
          ]
        },
        {
          styleClasses: 'none',
          fields: [
            {
              column: 24,
              type: 'app-text-area',
              model: 'textoCertidao',
              id: 'textarea_id',
              inputName: 'textoCertidao',
              visible: true,
              required: true,
              validator: 'required',
              disabled: false,
              elementLabel: 'Texto da certidao: ',
              autosize: true
            }
          ]
        }
      ]
    },
    PEAS_FILHO: {
      groups: [
        {
          styleClasses: 'none',
          fields: [
            {
              column: 6,
              required: true,
              type: 'elementInput',
              model: 'numeroLivro',
              inputName: 'numeroLivro',
              visible: true,
              disabled: false,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Nº do Título: ',
              clearable: true
            }
          ]
        },
        {
          styleClasses: 'none',
          fields: [
            {
              column: 24,
              type: 'app-text-area',
              model: 'textoCertidao',
              id: 'textarea_id',
              inputName: 'textoCertidao',
              visible: true,
              required: true,
              validator: 'required',
              disabled: false,
              elementLabel: 'Texto da certidao: ',
              autosize: true
            }
          ]
        }
      ]
    },
    REURB_INDIVIDUAL: {
      groups: [
        // 01 - caracteristicas do titulo
        {
          legend: '01 - CARACTERÍSTICAS DO TÍTULO',
          codigo: 'caracteristica_model',
          styleClasses: 'none',
          fields: [
            {
              column: 6,
              type: 'elementSelect',
              model: 'especie',
              inputName: 'especie',
              placeholder: 'Selecione',
              visible: true,
              disabled: false,
              required: true,
              validator: 'required',
              valueKey: 'name',
              values: [
                {
                  id: 'Título de Domínio',
                  name: 'TÍTULO DE DOMÍNIO'
                },
                {
                  id: 'Título de Reconhecimento de Domínio',
                  name: 'TÍTULO DE RECONHECIMENTO DE DOMÍNIO'
                },
                {
                  id: 'Título de Domínio Comunitário',
                  name: 'TÍTULO DE DOMÍNIO COMUNITÁRIO'
                },
                {
                  id: 'Outros',
                  name: 'OUTROS'
                }
              ],
              filterable: false,
              elementLabel: 'Especie: '
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'descricao',
              inputName: 'descricao',
              visible: false,
              disabled: false,
              required: false,
              readonly: false,
              styleClasses: '',
              validator: 'required',
              inputType: 'text',
              elementLabel: 'Descrição: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'numeroFolha',
              inputName: 'numeroFolha',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Nº do Título: ',
              clearable: true
            },
            {
              type: 'elementDatePicker',
              model: 'dataEmissao',
              inputName: 'dataEmissao',
              disabled: false,
              firstDayOfWeek: 1,
              elementLabel: 'Data de Emissão: ',
              placeholder: 'selecione a data',
              format: 'dd/MM/yyyy',
              dateType: 'date'
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'municipioEmissao',
              inputName: 'municipioEmissao',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Local de Emissão: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'ufEmissao',
              inputName: 'ufEmissao',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'UF: ',
              clearable: true
            },
            {
              column: 12,
              type: 'elementInput',
              model: 'numeroProcesso',
              inputName: 'numeroProcesso',
              visible: true,
              disabled: true,
              required: true,
              readonly: false,
              styleClasses: '',
              inputType: 'text',
              elementLabel: 'Processo Administrativo: ',
              clearable: true
            }
          ]
        },
        {
          legend: '02 - OUTORGANTE',
          styleClasses: 'none',
          fields: [
            {
              column: 24,
              type: 'elementInput',
              model: 'outorgante',
              inputName: 'outorgante',
              visible: true,
              validator: 'required',
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Nome do Outorgante: ',
              clearable: true
            }
          ]
        },
        {
          codigo: 'OUTORGADO',
          legend: '03 - OUTORGADO',
          styleClasses: 'none',
          fields: [
            {
              column: 24,
              type: 'elementInput',
              model: 'nomeOutorgado',
              inputName: 'nomeOutorgado',
              visible: true,
              validator: 'required',
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Nome do Outorgado: ',
              clearable: true,
              visiblePf: true,
              visiblePj: true
            },
            {
              type: 'elementSelect',
              model: 'nacionalidadeOutorgado',
              inputName: 'nacionalidadeOutorgado',
              placeholder: 'Selecione',
              visible: true,
              disabled: false,
              required: true,
              validator: 'required',
              valueKey: 'codigo',
              values: gentilicosTituloNameUpperCase,
              filterable: false,
              elementLabel: 'Nacionalidade: ',
              visiblePf: true,
              visiblePj: false
            },
            {
              type: 'elementSelect',
              model: 'estadoCivilOutorgado',
              inputName: 'estadoCivilOutorgado',
              placeholder: 'Selecione',
              visible: true,
              disabled: true,
              valueKey: 'codigo',
              values: estadoCivil,
              filterable: false,
              required: true,
              validator: 'required',
              elementLabel: 'Estado Civil: ',
              clearable: true,
              visiblePf: true,
              visiblePj: false
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'rgOutorgado',
              inputName: 'rgOutorgado',
              visible: true,
              disabled: false,
              required: false,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Nº do RG: ',
              clearable: true,
              visiblePf: true,
              visiblePj: false
            },
            {
              column: 6,
              type: 'elementSelect',
              model: 'orgaoExpedidorOutorgado',
              inputName: 'orgaoExpedidorOutorgadoSelect',
              placeholder: 'Selecione',
              visible: true,
              disabled: false,
              valueKey: 'codigo',
              values: orgaosExpedidoresNameUpperCase,
              filterable: false,
              required: false,
              elementLabel: 'Orgão expedidor: ',
              clearable: true,
              visiblePf: true,
              visiblePj: false
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'descricaoOrgaoExpedidorOutorgado',
              inputName: 'descricaoOrgaoExpedidorOutorgado',
              placeholder: 'Descrição',
              visible: false,
              disabled: false,
              filterable: false,
              required: true,
              validator: 'required',
              elementLabel: 'Descrição: ',
              clearable: true,
              visiblePf: true,
              visiblePj: false,
              inputType: 'text',
              maxlength: 15
            },
            {
              column: 6,
              type: 'elementSelect',
              model: 'ufRgOutorgado',
              inputName: 'ufRgOutorgado',
              placeholder: 'Selecione',
              visible: true,
              disabled: false,
              required: false,
              valueKey: 'codigo',
              values: siglasEstados(),
              filterable: false,
              elementLabel: 'UF do RG: ',
              clearable: true,
              visiblePf: true,
              visiblePj: false
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'cpfCnpjOutorgado',
              inputName: 'cpfCnpjOutorgado',
              visible: true,
              disabled: false,
              required: true,
              validator: [validaCpfCnpj],
              readonly: false,
              inputType: 'text',
              elementLabel: 'CPF/CNPJ: ',
              clearable: true,
              visiblePf: true,
              visiblePj: true,
              maxlength: 17
            }
          ]
        },
        {
          codigo: 'CONJUGE',
          styleClasses: 'none',
          fields: [
            {
              column: 24,
              type: 'elementInput',
              model: 'nomeConjuge',
              inputName: 'nomeConjuge',
              visible: true,
              disabled: false,
              required: true,
              validator: 'required',
              readonly: false,
              inputType: 'text',
              elementLabel: 'Cônjuge do Outorgado: ',
              clearable: true
            },
            {
              type: 'elementSelect',
              model: 'nacionalidadeConjuge',
              inputName: 'nacionalidadeConjuge',
              placeholder: 'Selecione',
              visible: true,
              disabled: false,
              required: true,
              validator: 'required',
              valueKey: 'codigo',
              values: gentilicosTituloNameUpperCase,
              filterable: false,
              elementLabel: 'Nacionalidade: '
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'rgConjuge',
              inputName: 'rgConjuge',
              visible: true,
              disabled: false,
              required: false,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Nº do RG: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementSelect',
              model: 'orgaoExpedidorConjuge',
              inputName: 'orgaoExpedidorConjugeSelect',
              placeholder: 'Selecione',
              visible: true,
              disabled: false,
              required: false,
              valueKey: 'codigo',
              values: orgaosExpedidoresNameUpperCase,
              filterable: false,
              elementLabel: 'Orgão expedidor: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'descricaoOrgaoExpedidorConjuge',
              inputName: 'descricaoOrgaoExpedidorConjuge',
              placeholder: 'Descrição',
              visible: false,
              disabled: false,
              filterable: false,
              required: true,
              validator: 'required',
              elementLabel: 'Descrição: ',
              clearable: true,
              visiblePf: true,
              visiblePj: false,
              inputType: 'text',
              maxlength: 15
            },

            {
              column: 6,
              type: 'elementSelect',
              model: 'ufRgConjuge',
              inputName: 'ufDoRgConjuge',
              placeholder: 'Selecione',
              visible: true,
              disabled: false,
              required: false,
              valueKey: 'codigo',
              values: siglasEstados(),
              filterable: false,
              elementLabel: 'UF do RG: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'cpfCnpjConjuge',
              inputName: 'cpfCnpjConjuge',
              visible: true,
              disabled: false,
              required: true,
              validator: [validaCpfCnpj],
              readonly: false,
              inputType: 'text',
              elementLabel: 'CPF/CNPJ: ',
              clearable: true,
              maxlength: 17
            }
          ]
        },
        {
          legend: '04 - DADOS DO IMÓVEL',
          codigo: 'CARACTERISTICA_IMOVEL',
          styleClasses: 'none',
          fields: [
            {
              column: 6,
              type: 'elementInput',
              model: 'latitude',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: false,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Latitude: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'longitude',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: false,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Longitude: ',
              clearable: true
            },
            {
              column: 12,
              type: 'elementInput',
              model: 'nomeImovel',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              validator: 'required',
              required: false,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Nome do Imóvel: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'glebaImovel',
              inputName: 'input_name',
              visible: true,
              validator: 'required',
              disabled: false,
              required: false,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Gleba do Imóvel: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'areaImovel',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: false,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Área do Imóvel: ',
              clearable: true,
              validator: [(value) => {
                if (value === '' || /^\d{1,3}(?:\.\d{3})*(?:,\d{1,4})?$|^\d+$/.test(value)) {
                  return []
                }
                return ['Área do imóvel inválida']
              }],
              set: (model, value) => {
                if (value === '') {
                  model.areaImovel = ''
                  return
                }
                let totCaracter = 14 // Total de caracteres máximo aceito contando as casas decimais e virgula
                let valueSemPonto = value.replace(/\./g, '')
                if (valueSemPonto.length <= totCaracter) {
                  const partes = value.split(',')
                  const teste = /^\d{1,3}(?:\.\d{3})*(?:,\d{1,4})?$|^\d+$/
                  if ((partes.length === 1 || ['', '0'].includes(partes[1]) || (partes[1].length <= 4 && partes[1]?.split('')?.pop() === '0')) && teste.test(partes[0])) {
                    model.areaImovel = value
                  } else if ((partes.length === 1 || partes[1].length <= 4) && (teste.test(value) || !isNaN(parseFloat(`${partes[0].replace(/[^0-9]/g, '')}.${partes[1]}`)))) {
                    const numeroFinal = parseFloat(`${partes[0].replace(/[^0-9]/g, '')}.${partes[1]}`).toLocaleString('pt-BR', {
                      maximumFractionDigits: 4
                    })
                    model.areaImovel = numeroFinal
                  }
                }
              }
            },
            {
              column: 12,
              type: 'elementInput',
              model: 'logradouroImovel',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: false,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Logradouro do Imóvel: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'numeroDeControle',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: false,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Número de controle: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'quadraDeControle',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: false,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Quadra de controle: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'numeroImovel',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: false,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Número do Imóvel: ',
              clearable: true
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'bairroImovel',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: false,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Bairro/Povoado: ',
              clearable: true
            },
            {
              column: 12,
              type: 'elementSelect',
              model: 'municipioImovel',
              inputName: 'especie',
              placeholder: 'Selecione',
              visible: true,
              validator: 'required',
              disabled: false,
              required: false,
              valueKey: 'name',
              values: [],
              filterable: true,
              elementLabel: 'Município do Imóvel: '
            },
            {
              column: 6,
              type: 'elementInput',
              model: 'precoImovel',
              inputName: 'input_name',
              visible: true,
              disabled: false,
              required: true,
              readonly: false,
              inputType: 'text',
              elementLabel: 'Preço do Imóvel: ',
              clearable: true,
              set: (model, value) => {
                if (value === '') {
                  model.precoImovel = ''
                  return
                }
                let totCaracter = 14 // Total de caracteres máximo aceito contando as casas decimais e virgula
                let valueSemPonto = value.replace(/\./g, '')
                if (valueSemPonto.length <= totCaracter) {
                  const partes = value.split(',')
                  const teste = /^\d{1,3}(?:\.\d{3})*(?:,\d{1,2})?$|^\d+$/
                  if ((partes.length === 1 || ['', '0'].includes(partes[1]) || (partes[1].length <= 2 && partes[1]?.split('')?.pop() === '0')) && teste.test(partes[0])) {
                    model.precoImovel = value
                  } else if ((partes.length === 1 || partes[1].length <= 2) && (teste.test(value) || !isNaN(parseFloat(`${partes[0].replace(/[^0-9]/g, '')}.${partes[1]}`)))) {
                    const numeroFinal = parseFloat(`${partes[0].replace(/[^0-9]/g, '')}.${partes[1]}`).toLocaleString('pt-BR', {
                      maximumFractionDigits: 2
                    })
                    model.precoImovel = numeroFinal
                  }
                }
              }
            }
          ]
        }
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/screens/analise/components/schemaTitulo/ma/schema.js